import { isTruthy } from "../lib/utils";

export interface IOrganizationProductInstance {
    id: string;
    genAIEnabled?: boolean;
    name: string;
    navigationUrl?: string;
    nickname?: string;
    optiIdEnabled?: boolean;
    region?: string;
    technicalContactEmail?: string;
    technicalContactName?: string;
    supportsGenAI?: boolean;
}

export class OrganizationProduct {
    constructor({
        allowCustomerDefinedRoles = false,
        hasUsageDashboard,
        isService,
        id,
        name,
        supportsGenAI,
        supportsTeams,
        instances
    }: {
        allowCustomerDefinedRoles?: boolean;
        hasUsageDashboard?: boolean;
        isService?: boolean;
        id: string;
        name: string;
        supportsGenAI?: boolean;
        supportsTeams?: boolean;
        instances: IOrganizationProductInstance[];
    }) {
        this.allowCustomerDefinedRoles = allowCustomerDefinedRoles;
        this.hasUsageDashboard = hasUsageDashboard || false;
        this.isService = isService || false;
        this.id = id;
        this.name = name;
        this.supportsGenAI = supportsGenAI || false;
        this.supportsTeams = supportsTeams || false;
        this.instances = instances?.map((i) => {
            return {
                ...i,
                genAIEnabled: isTruthy({ value: i.genAIEnabled }),
                optiIdEnabled: isTruthy({ value: i.optiIdEnabled })
            };
        });
    }
    allowCustomerDefinedRoles: boolean;
    hasUsageDashboard: boolean;
    isService: boolean;
    id: string;
    name: string;
    supportsGenAI?: boolean;
    supportsTeams?: boolean;
    instances: IOrganizationProductInstance[];
}
